// to check length of a given string
const checkLength=(item,len)=>{
    return item.length <= len ? true: false;
}

export default checkLength;